import React, { useEffect } from 'react';
import MainRoutes from "./MainRoutes";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { checkTokenAndLogout } from "./services/api";
import { HelmetProvider} from "react-helmet-async";

function App() {

    useEffect(() => {
        // Check token expiry every 5 minutes
        const interval = setInterval(checkTokenAndLogout, 5 * 60 * 1000);

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, []);

    return (
        <HelmetProvider>
        <div className="App">
            <MainRoutes/>
            <ToastContainer position="bottom-right" autoClose={5000} />
        </div>
        </HelmetProvider>
    );
}

export default App;